export const CategoriesHeavyMachinery = [
  "Catepillar",
  "Crawler Excavator",
  "Wheeled Excavator",
  "Komatsu",
  "Telescopic Book Excavators For Sale",
  "Komatsu",
  "Wheeled Excavator",
  "Komatsu",
  "Wheeled Excavator",
  "Catepillar",
  "Crawler Excavator",
  "Wheeled Excavator",
  "Komatsu",
  "Telescopic Book Excavators For Sale",
  "Komatsu",
  "Wheeled Excavator",
  "Komatsu",
  "Wheeled Excavator",
  "Catepillar",
  "Crawler Excavator",
  "Wheeled Excavator",
  "Komatsu",
  "Telescopic Book Excavators For Sale",
  "Komatsu",
  "Wheeled Excavator",
  "Komatsu",
  "Wheeled Excavator",
  "Catepillar",
  "Crawler Excavator",
  "Wheeled Excavator",
  "Komatsu",
  "Telescopic Book Excavators For Sale",
  "Komatsu",
  "Wheeled Excavator",
  "Komatsu",
  "Wheeled Excavator",
  "Catepillar",
  "Crawler Excavator",
  "Wheeled Excavator",
  "Komatsu",
  "Telescopic Book Excavators For Sale",
  "Komatsu",
  "Wheeled Excavator",
  "Komatsu",
  "Wheeled Excavator",
];

export const FooterPopularLinksData = [
  "Bobcat",
  "Wheel loader",
  "Excavator",
  "Cranes",
  "Telehandler",
  "Skid steer",
  "Dozer",
  "Tractor",
  "Bobcat",
  "WheelLoader",
  "Excavator",
  "Cranes",
  "Telehandler",
  "Skid steer",
  "Dozer",
  "Tractor",
  "Bobcat",
  "Wheel Loader",
];
